import { computed, defineComponent, ref } from 'vue';
import Menus from './components/menus.vue';
import { removeToken } from '@/utils/auth';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default defineComponent({
  name: 'Header',
  components: {
    Menus
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const info = computed(() => {
      return store.getters.userinfo.userName;
    });
    const menuData = ref([]);
    menuData.value = [{
      name: '概览',
      url: '/home',
      children: [{
        name: '全局概览',
        url: '/home'
      }, {
        name: '核心指标',
        url: '/core'
      }]
    }, {
      name: '设备管理',
      url: '/equipment',
      children: [{
        name: '设备列表',
        url: '/equipment/list'
      }, {
        name: '状态统计',
        url: '/equipment/state'
      }]
    }, {
      name: '实操考试分析',
      url: '/examAnalysis',
      children: [{
        name: '地区统计',
        url: '/examAnalysis/areaStatistics'
      }, {
        name: '作业科目分析',
        url: '/examAnalysis/jobSubject'
      }, {
        name: '考试计划详情',
        url: '/examAnalysis/examPlan'
      }, {
        name: '通过率',
        url: '/examAnalysis/passRate'
      }]
    }, {
      name: '考点分析',
      url: '/examSiteAnalysis',
      children: [{
        name: '考点概览',
        url: '/examSiteAnalysis/examSiteInfo'
      }, {
        name: '考点对比',
        url: '/examSiteAnalysis/examSiteCompared'
      }]
    }, {
      name: '培训分析',
      url: '/trainAnalysis',
      children: [{
        name: '学员概览',
        url: '/trainAnalysis/traineeList'
      }, {
        name: '在线学习',
        url: '/trainAnalysis/onlineLearn',
        isDisabled: true
      }, {
        name: '工种科目统计',
        url: '/trainAnalysis/typeSubjectCount',
        isDisabled: true
      }, {
        name: '培训机构列表',
        url: '/trainAnalysis/trainAgencyList',
        isDisabled: true
      }]
    }];

    const handleCommand = parameter => {
      if (parameter === 'exit') {
        store.dispatch('user/logout').then(res => {
          router.push('/login');
        });
      }
    };

    return {
      info,
      menuData,
      handleCommand
    };
  }

});